import useUpdateCalendarDay from '../../../hooks/useUpdateCalendarDay';
import DiceIcon from '../../../components/DiceIcon';

function InseminationDayToggle({ ipData, date, isFutureDate, setMessage }) {
  const { updateCalendarDay } = useUpdateCalendarDay();
  const isInseminationDay = ipData?.inseminationDay ?? false;

  const handleToggle = () => {
    if (isFutureDate) {
      setMessage({ type: 'alert', text: 'Cannot select for future date' });
      return;
    }
    setMessage(null);
    updateCalendarDay(date, 'inseminationDay', !isInseminationDay);
  };

  return (
    <button
      onClick={handleToggle}
      className={`flex flex-col items-center gap-1 rounded-xl border p-3 text-xs transition-colors ${
        isInseminationDay 
          ? 'border-4 border-[#bfdbfe] bg-white shadow-[inset_0_0_0_4px_#fce7f3] text-primary' 
          : 'border-border hover:border-primary/50'
      }`}
    >
      <DiceIcon />
      Insemination
    </button>
  );
}

export default InseminationDayToggle;
